<template>
  <v-row>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="occurs"
    >
      <label class="title-label">Occurs*</label>
      <v-select
        :items="occurOptions"
        v-model="need.occurs"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :error-messages="occursMessage"
      />
    </v-col>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      style="align-items: baseline"
      v-if="need.occurs == 'Daily'"
      ref="repeat"
    >
      <label class="title-label">Repeat Every*</label>
      <v-select
        :items="repeatOptions"
        v-model="need.repeat_every"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :error-messages="repeatMessage"
      />
    </v-col>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      v-if="need.occurs == 'Weekly'"
      ref="repeatOn"
    >
      <label class="title-label">Repeat On*</label>
      <div :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'">
        <v-checkbox
          v-for="day in [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'
          ]"
          :key="day"
          v-model="need.repeat_on"
          :label="day"
          :value="day"
          :error-messages="
            need.repeat_on && need.repeat_on.length > 0 ? '' : repeatOnMessage
          "
        />
      </div>
    </v-col>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      v-if="need.occurs == 'Monthly'"
      ref="selectDay"
    >
      <label class="title-label"
        >Select Day*
        <tip-icon>
          If 3rd Friday, then select Friday from the list.
        </tip-icon>
      </label>
      <v-radio-group
        v-model="need.dow"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        :error-messages="need.dow ? '' : selectDayMessage"
      >
        <v-radio label="Monday" value="Monday" />
        <v-radio label="Tuesday" value="Tuesday" />
        <v-radio label="Wednesday" value="Wednesday" />
        <v-radio label="Thursday" value="Thursday" />
        <v-radio label="Friday" value="Friday" />
        <v-radio label="Saturday" value="Saturday" />
        <v-radio label="Sunday" value="Sunday" />
      </v-radio-group>
    </v-col>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      v-if="need.occurs == 'Monthly'"
      ref="occurrence"
    >
      <label class="title-label"
        >Occurrence*
        <tip-icon>
          If 3rd Friday, then select 3 from the list.
        </tip-icon>
      </label>
      <v-radio-group
        v-model="need.occurrence"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        :error-messages="need.occurrence ? '' : occurrenceMessage"
      >
        <v-radio label="1" value="1" />
        <v-radio label="2" value="2" />
        <v-radio label="3" value="3" />
        <v-radio label="4" value="4" />
      </v-radio-group>
    </v-col>

    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="hours"
    >
      <label class="title-label"
        >Hours*
        <tip-icon>
          Enter the number of hours the volunteer is expected to work.<br />
          This number is used by your volunteer check-in feature.<br />
          For recurring needs, enter the average number of hours expected for
          each occurrence.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.hours"
        label="Example: 4 or 3.5"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :min="1"
        type="number"
        :error-messages="hoursMessage"
        @input="onChange"
      />
    </v-col>
    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="hours_description"
    >
      <label class="title-label"
        >Hours Description*
        <tip-icon>
          Let the volunteer know when the need is scheduled to start and end.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.hours_description"
        label="Example: 9am - 5pm"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :error-messages="hoursDescriptionMessage"
      />
    </v-col>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="capacity"
    >
      <label class="title-label"
        >Capacity*
        <tip-icon>
          Enter the number of volunteer spots available.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.capacity"
        label="Example: 30"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :min="1"
        type="number"
        :error-messages="capacityMessage"
        @input="onCapacityInput"
      />
    </v-col>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
    >
      <label class="title-label">
        Date Range*
      </label>
      <v-row>
        <v-col
          cols="6"
          class="align-baseline d-flex"
          :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
          ref="start_date"
        >
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formattedStartDate"
                label="Start Date"
                readonly
                solo
                flat
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
                :error-messages="startDateErrorMessage"
                :disabled="false"
              />
            </template>
            <v-date-picker
              v-model="need.start_date"
              :min="new Date().toISOString().substr(0, 10)"
              @input="startDateMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6" ref="end_date">
          <v-menu
            v-model="date_picker_end"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formattedEndDate"
                label="End Date"
                :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
                solo
                flat
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                autocomplete="off"
                :error-messages="endDateErrorMessage"
                readonly
              />
            </template>
            <v-date-picker
              v-model="need.end_date"
              no-title
              scrollable
              :min="need.start_date || new Date().toISOString().substr(0, 10)"
              @input="date_picker_end = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import TipIcon from "@/components/common/TipIcon.vue";
export default {
  components: { TipIcon },
  props: {
    need: Object,
    hoursMessage: String,
    capacityMessage: String,
    startDateErrorMessage: String,
    endDateErrorMessage: String,
    repeatMessage: String,
    repeatOnMessage: String,
    selectDayMessage: String,
    onChange: Function,
    occursMessage: String,
    hoursDescriptionMessage: String,
    occurrenceMessage: String
  },
  data() {
    return {
      occurOptions: ["Daily", "Weekly", "Monthly"],
      repeatOptions: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30"
      ],
      repeatByOptions: ["Date", "Day of the Week"],
      startDate: null,
      startDateMenu: false,
      date_picker_end: false
    };
  },
  computed: {
    formattedStartDate() {
      if (!this.need.start_date) return "";
      const [year, month, day] = this.need.start_date.split("-");
      return `${month}/${day}/${year}`; // Format as MM/DD/YYYY
    },
    formattedEndDate() {
      if (!this.need.end_date) return "";
      const [year, month, day] = this.need.end_date.split("-");
      return `${month}/${day}/${year}`; // Format as MM/DD/YYYY
    }
  },
  methods: {
    onCapacityInput(value) {
      const numericValue = value.replace(/[^0-9]/g, "");
      if (numericValue === "" || Number(numericValue) < 1) {
        this.need.capacity = 1;
      } else {
        this.need.capacity = Number(numericValue);
      }
    },
    changeDateFormat(dateStr) {
      return `${dateStr.substring(5, 7)}/${dateStr.substring(
        8,
        10
      )}/${dateStr.substring(0, 4)}`;
    },
    // onSaveStartDate(dateStr) {
    //   this.need.start_date = this.changeDateFormat(dateStr);
    //   this.date_picker_start = false;
    // },
    // onSaveEndDate(dateStr) {
    //   this.need.end_date = this.changeDateFormat(dateStr);
    //   this.date_picker_end = false;
    // }
    onSaveStartDate(dateStr) {
      this.need.start_date = dateStr; // Store in YYYY-MM-DD format
      this.startDateMenu = false;
    },
    onSaveEndDate(dateStr) {
      this.need.end_date = dateStr; // Store in YYYY-MM-DD format
      this.date_picker_end = false;
    },
    validateDates() {
      if (this.need.start_date && this.need.end_date) {
        const startDateObj = new Date(this.need.start_date);
        const endDateObj = new Date(this.need.end_date);

        if (startDateObj > endDateObj) {
          this.endDateErrorMessage = "Start date must be before end date.";
          return false;
        }
      }
      this.endDateErrorMessage = null;
      return true;
    }
  },
  mounted() {
    // Remove auto-set of start_date, let user pick it
  }
};
</script>
<style scoped>
.title-label {
  width: 200px;
}
</style>
